import log from 'loglevel';
import { AIResponseDto, SubmitAIRequestDto } from 'types/ai-generation';

import { apiClient } from '.';

export const submitTouchTriggerAIGeneration = async (touchTriggerId: string, submitAIRequestDto: SubmitAIRequestDto): Promise<AIResponseDto> => {
  const response = await apiClient.post(`/ai/touch-trigger/${touchTriggerId}/generate`, submitAIRequestDto);

  log.debug('called submitAIRequest and got', response.data);

  return response.data;
};
